import {locationCardSchema} from '../../../../../schemas/locationCardSchema';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {DTStoreNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

const DEFAULT_DISTANCE_FALLBACK_OPTION = 10;

export function convertLocationAICardToAPICard(locationCard: z.input<typeof locationCardSchema>) {
  return {
    ...getAICardBaseDetails(locationCard),
    type: NodeType.STORE,
    locationFeedId: locationCard.locationFeedId,
    locationSetId: locationCard.locationSetId,
    maxDistKm: locationCard.maxDistKm ?? DEFAULT_DISTANCE_FALLBACK_OPTION,
    maxDistFallbackOption: 0,
    topLocationIds: locationCard.topLocationIds ?? [],
    locationTargetingMethod: locationCard.locationTargetingMethod,
  } as Omit<DTStoreNode, 'outputs' | 'inputs'>;
}
